var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-text-time-mobile",class:{dark:_vm.dark}},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"label",style:({color: _vm.color})},[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }